const CryptoJS = require('crypto-js');

class CryptoHelper {
    constructor(secretKey) {
        this.secretKey = secretKey;
    }

    encrypt(data) {
        try {
            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
            return encrypted;
        } catch (err) {
            console.error('Encryption error:', err);
            return null;
        }
    }

    decrypt(encryptedData) {
        try {
            const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
            const decrypted = bytes.toString(CryptoJS.enc.Utf8);
            return JSON.parse(decrypted);
        } catch (err) {
            console.error('Decryption error:', err);
            return null;
        }
    }
}

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;;
const cryptoHelpers = new CryptoHelper(SECRET_KEY);

module.exports = cryptoHelpers;
